import { render, staticRenderFns } from "./ForgotPwd.vue?vue&type=template&id=329e3530&scoped=true&"
import script from "./ForgotPwd.vue?vue&type=script&lang=js&"
export * from "./ForgotPwd.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPwd.vue?vue&type=style&index=0&id=329e3530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329e3530",
  null
  
)

export default component.exports